<template>
  <div class="zm-collapse-item" :class="{'is-active': isActive}">
    <div
      :aria-controls="`zm-collapse-content-${id}`"
      :aria-describedby="`zm-collapse-content-${id}`"
    >
      <div
        class="zm-collapse-item__header"
        @click="handleHeaderClick"
        role="button"
        :aria-expanded="isActive.toString()"
        :id="`zm-collapse-head-${id}`"
        tabindex="0"
        @keydown.enter.space.prevent.stop="handleEnterClick"
        :class="{
          'focusing': focusing,
          'is-active': isActive
        }"
        @focus="handleFocus"
        @blur="focusing = false"
      >
        <i
          class="zm-collapse-item__arrow zm-icon-right"
          :class="{'is-active': isActive}"
        >
        </i>
        <slot name="title">
          {{title}}
        </slot>
      </div>
    </div>
    <zm-collapse-transition>
      <div
        class="zm-collapse-item__wrap"
        v-show="isActive"
        role="tabpanel"
        :aria-hidden="!isActive"
        :aria-labelledby="`zm-collapse-head-${id}`"
        :id="`zm-collapse-content-${id}`"
      >
        <div class="zm-collapse-item__content">
          <slot></slot>
        </div>
      </div>
    </zm-collapse-transition>
  </div>
</template>
<script>
  import ZmCollapseTransition from '../../transitions/collapse-transition';
  import Emitter from '../../mixins/emitter';
  import { generateId } from '../../utils/util';

  export default {
    name: 'ZmCollapseItem',

    componentName: 'ZmCollapseItem',

    mixins: [Emitter],

    components: { ZmCollapseTransition },

    data() {
      return {
        contentWrapStyle: {
          height: 'auto',
          display: 'block'
        },
        contentHeight: 0,
        focusing: false,
        isClick: false
      };
    },

    inject: ['collapse'],

    props: {
      title: String,
      name: {
        type: [String, Number],
        default() {
          return this._uid;
        }
      }
    },

    computed: {
      isActive() {
        return this.collapse.activeNames.indexOf(this.name) > -1;
      },
      id() {
        return generateId();
      }
    },

    methods: {
      handleFocus() {
        setTimeout(() => {
          if (!this.isClick) {
            this.focusing = true;
          } else {
            this.isClick = false;
          }
        }, 50);
      },
      handleHeaderClick() {
        this.dispatch('ZmCollapse', 'item-click', this);
        this.focusing = false;
        this.isClick = true;
      },
      handleEnterClick() {
        this.dispatch('ZmCollapse', 'item-click', this);
      }
    }
  };
</script>

<style lang="scss">
  @import "../../scss/mixins/mixins";
  @import "../../scss/common/var";

  @include b(collapse-item) {
    @include e(header) {
      padding-top: $--collapse-header-padding;
      padding-bottom: $--collapse-header-padding;
      background-color: $--collapse-header-fill;
      color: $--collapse-header-color;
      cursor: pointer;
      border-bottom: 1px solid $--collapse-border-color;
      font-size: $--collapse-header-size;
      font-weight: 500;
      transition: border-bottom-color .3s;
      outline: none;
      @include e(arrow) {
        margin-right: 8px;
        transition: transform .3s;
        float: right;
        @include when(active) {
          transform: rotate(90deg);
        }
      }
      &.focusing:focus:not(:hover){
        color: $--color-primary;
      }
      @include when(active) {
        border-bottom-color: transparent;
      }
    }

    @include e(wrap) {
      will-change: height;
      background-color: $--collapse-content-fill;
      overflow: hidden;
      box-sizing: border-box;
      border-bottom: 1px solid $--collapse-border-color;
    }

    @include e(content) {
      padding-bottom: 25px;
      font-size: $--collapse-content-size;
      color: $--collapse-content-color;
      line-height: 1.769230769230769;
    }

    &:last-child {
      margin-bottom: -1px;
    }
  }
  .zm-theme--dark {
    @include b(collapse-item) {
      @include e(header){
        background-color: transparent;
        color: #fff;
        border-color: #252a30;
      }
      @include e(wrap){
        background-color: transparent;
        border-color: #252a30;
      }
      @include e(content){
        color: #fff;
      }
    }
  }
</style>
